import { render, staticRenderFns } from "./ConnectorResource.vue?vue&type=template&id=5b93f66a&"
import script from "./ConnectorResource.vue?vue&type=script&lang=js&"
export * from "./ConnectorResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports